import { render, staticRenderFns } from "./admin.order.vue?vue&type=template&id=5e2078d0&"
import script from "./admin.order.vue?vue&type=script&lang=js&"
export * from "./admin.order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports